module.exports = __webpack_public_path__ + "components/discount-pages/db-journey/static/db-1600@2x-5b6f18ada6a3ef5d9ae61332eb9be669.jpg";